import React from 'react';
import { AritoAppBar } from '@/components/custom/arito/app-bar';
import { Toaster } from '@/components/ui/toaster';
import { useAppPathname } from '@/routing';
import { isKnownViteRoutePath } from '@/routes/route-map';

interface ViteAppShellProps {
  children: React.ReactNode;
}

const isAuthRoute = (pathname: string) => pathname === '/xac-thuc' || pathname.startsWith('/xac-thuc/');

export function ViteAppShell({ children }: ViteAppShellProps) {
  const pathname = useAppPathname();
  const shouldShowAppBar = !isAuthRoute(pathname) && isKnownViteRoutePath(pathname);

  if (isAuthRoute(pathname)) {
    return (
      <>
        <main className='flex min-h-0 flex-1 flex-col overflow-auto bg-white'>{children}</main>
        <Toaster />
      </>
    );
  }

  return (
    <>
      <div className='flex h-screen w-full flex-col overflow-hidden bg-white'>
        {shouldShowAppBar && <AritoAppBar />}
        <main className='flex min-h-0 w-full flex-1 flex-col overflow-auto bg-white'>{children}</main>
      </div>
      <Toaster />
    </>
  );
}
